import { motion } from "framer-motion";
import { BadgeDollarSign, Smartphone, ShieldCheck, Headphones, Zap } from "lucide-react";

const reasons = [
  { icon: BadgeDollarSign, title: "Zero Fees", desc: "No hidden charges on deposits or withdrawals — keep 100% of your profits." },
  { icon: Smartphone, title: "User Friendly Platform", desc: "Intuitive interface designed for both beginners and experienced investors." },
  { icon: ShieldCheck, title: "Risk Management Tools", desc: "Advanced algorithms and stop-loss mechanisms to protect your investments." },
  { icon: Headphones, title: "Expert Service", desc: "Dedicated support team and professional advisors available around the clock." },
  { icon: Zap, title: "Fast Withdrawals", desc: "Request withdrawals anytime — processed and delivered within hours, not days." },
];

const WhyChooseSection = () => {
  return (
    <section className="py-24">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="font-display text-3xl font-bold gradient-gold-text md:text-4xl">
            Why Choose Prime Profits?
          </h2>
          <p className="mt-4 text-muted-foreground font-body text-lg">
            The trusted platform for smart crypto investing.
          </p>
        </motion.div>

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {reasons.map((r, i) => (
            <motion.div
              key={r.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="rounded-xl border border-gold-dark/30 bg-card p-6 text-center transition-all hover:border-gold/50 hover:glow-gold"
            >
              <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full gradient-gold">
                <r.icon className="h-7 w-7 text-primary-foreground" />
              </div>
              <h3 className="mt-5 font-display text-base font-semibold text-gold">{r.title}</h3>
              <p className="mt-3 text-sm text-muted-foreground font-body">{r.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
